<script lang="ts">
  /**
   * Completed Brief Builder briefs use the full legacy BriefView chrome
   * (versions, alignment, answers + scores, PDF, GapFinder, etc.).
   */
  import BriefView from '../brief/BriefView.svelte';

  export let briefId: string;
</script>

<BriefView {briefId} builderFlow={true} />
